// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteShopArticleTaxHistoryByIdRequestModel from '../../model/delete-shop-article-tax-history-by-id-request-model';
import DeleteShopArticleTaxHistoryByIdRequestDTO from '../dto/delete-shop-article-tax-history-by-id-request-dto';
import dtoSchema from '../schemas/delete-shop-article-tax-history-by-id-request-schema';

export default abstract class DeleteShopArticleTaxHistoryByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteShopArticleTaxHistoryByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteShopArticleTaxHistoryByIdRequestDTO>): DeleteShopArticleTaxHistoryByIdRequestModel;
  static toModel(dto: DeepPartial<DeleteShopArticleTaxHistoryByIdRequestDTO> | undefined | null): DeleteShopArticleTaxHistoryByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteShopArticleTaxHistoryByIdRequestDTO> | undefined | null): DeleteShopArticleTaxHistoryByIdRequestModel | undefined {
    return dto ? new DeleteShopArticleTaxHistoryByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteShopArticleTaxHistoryByIdRequestModel> | DeleteShopArticleTaxHistoryByIdRequestModel): DeleteShopArticleTaxHistoryByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteShopArticleTaxHistoryByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteShopArticleTaxHistoryByIdRequestModel, can not map to DeleteShopArticleTaxHistoryByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
